import { Component, OnDestroy, OnInit } from '@angular/core';
import { CompetencyStatusService } from '@app/competencies/services/competency-status.service';
import { NotificationSignalRService } from '@app/notification/services/notification-signalR.service';
import { NotificationDispatcherService } from '@app/shared/notification/notification-dispatcher.service';
import { AuthService } from '@app/shared/services/auth.service';
import { Subject, merge, takeUntil } from 'rxjs';

@Component({
	selector: 'notification-negotiation',
	template: ''
})
export class NotificationNegotiationComponent implements OnInit, OnDestroy {

	private readonly isDestroyed: Subject<void> = new Subject();
	private notificationsInitialized = false;

	constructor (
		private readonly authService: AuthService,
		private readonly notificationDispatcherService: NotificationDispatcherService,
		private readonly notificationSignalRService: NotificationSignalRService,
		private readonly competencyStatusService: CompetencyStatusService
	) { }

	ngOnInit () {
		if (this.authService.isLoggedIn()) {
			this.setupNotifications();
		}

		this.subscribeToAuthenticationSucceed();
		this.subscribeToLogoutSucceeded();
	}

	ngOnDestroy (): void {
		this.isDestroyed.next();
		this.isDestroyed.complete();
	}

	private subscribeToAuthenticationSucceed (): void {
		this.authService
			.onAuthenticationSucceed
			.pipe(takeUntil(this.isDestroyed))
			.subscribe(() => this.setupNotifications());
	}

	private subscribeToLogoutSucceeded (): void {
		this.authService
			.onLogoutSucceeded
			.pipe(takeUntil(this.isDestroyed))
			.subscribe(() => this.release());
	}

	private setupNotifications (): void {
		if (this.notificationsInitialized) {
			return;
		}

		this.notificationsInitialized = true;
		void this.notificationSignalRService.init();
		this.competencyStatusService.init();

		this.notificationSignalRService
			.onNotificationReceived
			.pipe(
				takeUntil(merge(
					this.isDestroyed,
					this.authService.onLogoutSucceeded
				))
			)
			.subscribe(notification => {
				if (!notification) {
					return;
				}
				this.notificationDispatcherService.dispatch(notification);
			});
	}

	private release (): void {
		this.notificationsInitialized = false;
		void this.notificationSignalRService.release();
	}
}